import { Pipe, PipeTransform } from '@angular/core';
import { Reservation, ReservationStatus, Table } from '@model/reservation';
import { TableImageType } from '@model/tables-plan';
import { ReservationService } from 'src/app/lib/reservation.service';

@Pipe({
  name: 'tableImage'
})
export class TableImagePipe implements PipeTransform {

  transform(value: TableImageType | undefined, ...args: unknown[]): string {

    const table: Table = args[0] as Table;
    const reservations: Reservation[] = args[1] as Reservation[];
    const reservationStatus: ReservationStatus = (reservations ?? []).length > 0 ? reservations[0].reservationDetails.reservationsStatus : 'NotConfirmed';
    const selected: boolean = args[2] as boolean;
    const reservationAssignTablesMode: boolean = args[3] as boolean;
    const assignTablesReservation: Reservation | null = args[4] as Reservation | null;
    const conflictingReservations: Reservation[] = args[5] as Reservation[];
    const editMode: boolean = args[6] as boolean;
    const recommended = this.isRecommended(table, reservations, reservationAssignTablesMode, assignTablesReservation, conflictingReservations);
    const unavailable = this.isUnavailable(reservations, reservationAssignTablesMode, conflictingReservations);

    let imageColor = '';
    if (editMode && !selected) {
      imageColor = '';
    } else if (selected) {
      imageColor = '_selected';
    } else if (recommended) {
      imageColor = '_blue';
    } else if (unavailable) {
      imageColor = '_red';
    } else {
      switch (reservationStatus) {
        case 'CheckedIn':
        case 'CheckedIn(Partial)':
        case 'WalkIn':
          imageColor = '_red';
          break;
        case 'Dessert':
          imageColor = '_orange';
          break;
        case 'Payment':
          imageColor = '_green';
          break;
        case 'Prepare':
          imageColor = '_purple';
          break;
        default:
          imageColor = '';
      }
    }

    let imageType: string = '';

    switch (value) {
      case 'square2':
        imageType = 'cap_2_square';
        break;
      case 'square4':
        imageType = 'cap_4_square';
        break;
      case 'rect4':
        imageType = 'cap_4_rect';
        break;
      case 'rect6':
        imageType = 'cap_6_rect';
        break;
      case 'rect8':
        imageType = 'cap_8_rect';
        break;
      case 'rect10':
        imageType = 'cap_10_rect';
        break;
      case 'round2':
        imageType = 'cap_2_round';
        break;
      case 'round4':
        imageType = 'cap_4_round';
        break;
      case 'round6':
        imageType = 'cap_6_round';
        break;
      case 'round8':
        imageType = 'cap_8_round';
        break;
      case 'round10':
        imageType = 'cap_10_round';
        break;
      case 'seabed':
      case 'rect2':
        imageType = 'cap_seabed';
        break;
      default:
        imageType = '';
    }

    return `/assets/images/tables/${imageType}${imageColor}.png`;
  }

  isRecommended(
    table: Table | null, 
    tableReservations: Reservation[], 
    reservationAssignTablesMode: boolean, 
    assignTablesReservation: Reservation | null,
    conflictingReservations: Reservation[],
    ) {
    
    if (!reservationAssignTablesMode 
      || conflictingReservations.length > 0
      || assignTablesReservation?.reservationDetails == null
      || table == null
      || table?.minCapacity == null
      || table?.minCapacity <= 0
      || table?.maxCapacity == null
      || table?.maxCapacity <= 0) {
      return false;
    }
    
    const covers = assignTablesReservation.reservationDetails.covers;
    
    return covers >= table?.minCapacity && covers <= table?.maxCapacity;
  }
  
  isUnavailable(
    tableReservations: Reservation[], 
    reservationAssignTablesMode: boolean, 
    conflictingReservations: Reservation[]
  ) {
    if (!reservationAssignTablesMode 
      || tableReservations.length <= 0) {
      return false;
    }

    return conflictingReservations.length > 0;
  }

}
